import React from "react";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";

function Upload_details() {
    const buttonStyle = {
        margin: "10px",
        width: "400px",
        height: "100px",
        color: "black",
        backgroundColor: "#FFF2CC",
        border: "1px solid #e0c97f"
    };
    return (
        <div className="text-center" style={{ position: "relative", minHeight: "70vh" }}>
            <h2>Upload</h2>

            <Link to="/clinical-profile">
                <Button
                    variant="warning"
                    className="px-4"
                    style={buttonStyle}
                >
                    Clinical Profile
                </Button>
            </Link>
            <br />

            <Link to="/molecular-profile">
                <Button
                    variant="warning"
                    className="px-4"
                    style={buttonStyle}
                >
                    Molecular Profile
                </Button>
            </Link>



         
        </div>
    );
}

export default Upload_details;
